/** @format */

import { CustomerActionTypes } from './customer.types';

export const addCustomer = (customer) => ({
  type: CustomerActionTypes.ADD_CUSTOMER,
  payload: customer,
});

export const updateMessageData = (customer) => ({
  type: CustomerActionTypes.UPDATE_MESSAGE_DATA,
  payload: customer,
});

export const clearCustomerSelection = () => ({
  type: CustomerActionTypes.CLEAR_CUSTOMER_SELECTION,
  payload: null,
});

export const removeCustomer = (customer) => ({
  type: CustomerActionTypes.REMOVE_CUSTOMER,
  payload: customer,
});

export const customerDataReset = () => ({
  type: CustomerActionTypes.CUSTOMER_DATA_RESET,
});
